<template>
  <component
    :is="navigable ? 'button' : 'div'"
    class="flex flex-col flex-1 rounded-2xl border border-grey-200 bg-white p-3"
    :class="navigable ? 'cursor-pointer hover:border-royal-300 text-left' : ''"
    v-bind="navigable ? { type: 'button' } : {}"
    @click="handleClick"
  >
    <div
      :class="[
        'flex w-full mb-6',
        navigable ? 'items-center justify-between' : 'items-start',
      ]"
    >
      <div
        v-if="icon || $slots.icon"
        :class="[
          'w-8 h-8 rounded-lg flex items-center justify-center border-2 border-white',
          iconBgClass,
          iconRingClass,
        ]"
      >
        <slot v-if="$slots.icon" name="icon" />
        <component v-else :is="icon" :class="['w-5 h-5', iconColorClass]" />
      </div>
      <div v-else :class="['w-8 h-8 rounded-lg', iconBgClass]" />
      <ChevronRightIcon v-if="navigable" aria-hidden="true" class="w-5 h-5 text-royal-500 flex-shrink-0" />
    </div>
    <span class="text-base font-normal text-royal-950">{{ value }}</span>
    <span class="text-label-xs text-grey-600"><slot name="label">{{ label }}</slot></span>
  </component>
</template>

<script setup lang="ts">
import type { Component } from 'vue'
import { ChevronRightIcon } from '@ecx/ui/icons'

const props = withDefaults(
  defineProps<{
    value: number | string
    label: string
    icon?: Component
    iconBgClass?: string
    iconColorClass?: string
    iconRingClass?: string
    navigable?: boolean
  }>(),
  {
    icon: undefined,
    iconBgClass: 'bg-grey-100',
    iconColorClass: 'text-grey-600',
    iconRingClass: '',
    navigable: false,
  },
)

const emit = defineEmits<{
  (e: 'navigate'): void
}>()

function handleClick() {
  if (props.navigable) {
    emit('navigate')
  }
}
</script>
